/**
 * Created by shubham on 7/6/18.
 */

import { Component, Input, OnInit } from '@angular/core';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import { HttpService } from '../shared/services/http.service'
import { SOCDetailsActionComponent } from '../dialog/dialog.component';

@Component({
    selector:'socId-details',
    template: require('./socIdDetails.component.html'),
})
export class socDetailsComponent implements OnInit {
    @Input() pageName:any;
    @Input() returnOrderId: any;
    socDetailList: any;
    dialogRef;

    constructor(public dialog: MdDialog, private http:HttpService) {}

    ngOnInit() {
    }

    public socDetailsByReturnOrderId() {
        let returnOrderId;
        if(this.pageName == 'dashboard'){
            returnOrderId = this.returnOrderId['orderId'];
        } else{
            returnOrderId = this.returnOrderId;
        }
        this.http.getRequest('/returnOrder/v1/getSOCDataByOrderId?sapOrderId='+returnOrderId).subscribe(
            res => {this.saveSOCDetailsByReturnOrderId(returnOrderId, res)},
            err => {
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = err;
                }
                this.http.onEnd();
            }
        );
    }

    public saveSOCDetailsByReturnOrderId(orderId, res){
        if(res.status == 'Success'){
            this.dialogRef = this.dialog.open(SOCDetailsActionComponent);
            this.dialogRef.componentInstance.socDetailList = res['items'];
            this.dialogRef.componentInstance.returnOrderId = orderId;
        } else if(res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            if(res.errorMessage){
                this.dialogRef.componentInstance.msg = res.errorMessage;
            } else {
                this.dialogRef.componentInstance.msg = 'Failed to process request.';
            }
        }
        this.http.onEnd();
    }

    public closeDialog(){
        this.dialog.closeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/socIdDetails/socIdDetails.component.ts